<script lang="ts" setup>
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { FormSchema } from '@/pages/carts/show.vue'
const { form } = defineProps<{
    form: FormSchema
}>()

const emit = defineEmits(['searchAddressByZipCode'])
</script>

<template>
    <div class="grid gap-x-2 gap-y-6 md:grid-cols-2 lg:gap-x-8">
        <div class="flex flex-col gap-2">
            <Label required for="zip_code">{{ $t('Postal Code') }} </Label>
            <Input type="text" v-model="form.zip_code" />

            <p v-if="form.errors.zip_code" class="text-destructive mt-px text-xs">{{ $t(form.errors.zip_code) }}</p>
        </div>

        <div class="flex flex-col gap-2">
            <Label required for="street">{{ $t('Address') }} </Label>
            <Input id="street" type="text" v-model="form.street" />
            <p v-if="form.errors.street" class="text-destructive mt-px text-xs">{{ $t(form.errors.street) }}</p>
        </div>

        <div class="flex flex-col gap-2">
            <Label required for="number">{{ $t('Number') }} </Label>
            <Input id="number" type="text" v-model="form.number" />
            <p v-if="form.errors.number" class="text-destructive mt-px text-xs">{{ $t(form.errors.number) }}</p>
        </div>

        <div class="flex flex-col gap-2">
            <Label for="additional_info">{{ $t('Complement') }} </Label>
            <Input id="additional_info" type="text" v-model="form.additional_info" />
            <p v-if="form.errors.additional_info" class="text-destructive mt-px text-xs">{{ $t(form.errors.additional_info) }}</p>
        </div>

        <div class="flex flex-col gap-2">
            <Label for="district">{{ $t('Neighborhood') }} </Label>
            <Input id="district" type="text" v-model="form.district" />
            <p v-if="form.errors.district" class="text-destructive mt-px text-xs">{{ $t(form.errors.district) }}</p>
        </div>

        <div class="flex flex-col gap-2">
            <Label required for="city">{{ $t('City') }} </Label>
            <Input id="city" type="text" v-model="form.city" />
            <p v-if="form.errors.city" class="text-destructive mt-px text-xs">{{ $t(form.errors.city) }}</p>
        </div>

        <div class="flex flex-col gap-2">
            <Label required for="state">{{ $t('State') }} </Label>
            <Input id="state" type="text" v-model="form.state" />

            <p v-if="form.errors.state" class="text-destructive mt-px text-xs">{{ $t(form.errors.state) }}</p>
        </div>

        <div class="flex flex-col gap-2">
            <Label required for="country">{{ $t('Country') }} </Label>
            <Input id="country" type="text" v-model="form.country" />
            <p v-if="form.errors.country" class="text-destructive mt-px text-xs">{{ $t(form.errors.country) }}</p>
        </div>
    </div>
</template>
